// The single predicate that decides whether QR dining runs the captain
// (table-session / KOT / pay-at-counter) flow instead of the normal order flow.
//
// ALL of these must hold, otherwise the caller falls back to the normal flow:
//   1. the restaurant's config flag `qr_captain_flow` is on,
//   2. a table is selected (the customer arrived via a QR scan),
//   3. that table resolved to a numeric table_id (backend resolver succeeded),
//   4. the order is dine-in (absent orderOption counts as dine — the cart
//      forces "dine" whenever a table is set; takeaway-at-table opts out).
//
// Any doubt = false: falling back to the normal dine flow is always safe (it
// still works off the raw table_no string), while wrongly entering captain
// mode would skip payment entirely.
export function isQrCaptainMode({
  restaurantConfig,
  selectedTable,
  tableInfo,
  orderOption,
} = {}) {
  // restaurantConfig initialises as [] in AppState before the config endpoint
  // answers — an array (or anything non-object) can never carry the flag.
  const config =
    restaurantConfig &&
    typeof restaurantConfig === "object" &&
    !Array.isArray(restaurantConfig)
      ? restaurantConfig
      : null;
  const flagOn =
    config?.qr_captain_flow === true || config?.qr_captain_flow === "true";
  if (!flagOn) return false;

  if (!selectedTable) return false;

  const tableId = Number(tableInfo?.table_id);
  if (!Number.isFinite(tableId) || tableId <= 0) return false;

  if (orderOption != null && orderOption !== "" && orderOption !== "dine") {
    return false;
  }

  return true;
}
